import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import dynamic from 'next/dynamic'

import useMedia from 'utils/hooks/useMedia'
import Logo from 'components/assets/logo.svg'
import Meta from 'components/layouts/meta'
const Loader = dynamic(() => import('components/utils/loaders/pageLoader'), { ssr: false })

const LayoutWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  max-width: 100%;
  margin: 0;

  @media (max-height: 580px) { 
    min-height: 125vh;
  }
`

const ContentBox = styled.div`
  padding: 50px;
  width: 460px;
  max-width: 100%;
`

const LogoLink = styled.a`
  position: absolute;
  top: 0;
  left: 80px;
`

export default function FormLayout ({ children, title, path, image, description, loading }) {
  const isWide = useMedia({ minWidth: 767 })

  return (
    <>
      <Meta title={title} path={path} image={image} description={description} />
      { !isWide
        ? <div style={{ display: 'flex', justifyContent: 'center', marginBottom: -70 }}>
            <Logo width="200px" height="141px" alt="Shareline: Invest in Private Tech Companies" />
          </div>
        : null }

      <LayoutWrapper>
        { isWide
          ? <LogoLink href="/" title="Shareline: Invest in Private Tech Companies">
              <Logo width="200px" height="141px" alt="Shareline: Invest in Private Tech Companies" />
            </LogoLink>
          : null }

        { loading
          ? <Loader />
          : <ContentBox>
              { children }
            </ContentBox> }
      </LayoutWrapper>
    </>
  )
}

FormLayout.propTypes = {
  children: PropTypes.any,
  sTitle: PropTypes.string,
  title: PropTypes.string,
  path: PropTypes.string,
  image: PropTypes.string,
  loading: PropTypes.bool,
  description: PropTypes.string
}
